import React from "react";
import * as utils from 'services/utility/utils';

import {
    Row,
    Table,
    Modal,
    Col
} from "reactstrap";


class SearchClientPopup extends React.Component {

    handleClose = () => {
        this.props.closePopUp()
    }

    redirect = (item, code) => {
        this.props.history.push(`/admin/redirect/${item}/${code}`);
        this.props.closePopUp();
    }

    render() {
        return (
            <>
                <Modal
                    isOpen={this.props.showPopUp}
                    toggle={() => this.handleClose()} size="md" backdrop="static" >

                    <div className="modal-header">
                        <h6 className="modal-title" id="modal-title-default">
                            Search Clients
                                </h6>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.handleClose()}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <Row><Col className="mb-3" md="12">
                        <Table size="sm" >
                            <thead className="thead-light" >
                                <tr>
                                    <th className="pl-2 pr-2">Id</th>
                                    <th className="pl-2 pr-2">FIRST NAME</th>
                                    <th className="pl-2 pr-2">LAST NAME</th>
                                    <th className="pl-2 pr-2">Status</th>
                                    <th className="pl-2 pr-2">Company Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.data && this.props.data.length > 0 && this.props.data.map((item, i) => {
                                    return <tr key={i}>
                                        <td >
                                            <button type="button"
                                                className="link-button"
                                                onClick={() => this.redirect(item.reference, item.code)}>
                                                {item.friendly_id}
                                            </button>
                                        </td>
                                        <td >{item.first_name}</td>
                                        <td >{item.last_name}</td>
                                        <td>{utils.transFormValueText(item.status, this.props.companyStatus, "id", "name")}</td>
                                        <td>{item.code}</td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                    </Col></Row>
                </Modal>
            </>

        );
    }
}
export default SearchClientPopup;